module.exports = __webpack_public_path__ + "img/turkey-logo-icon.07599e92.png";